import React from "react";
import { NavLink } from "react-router-dom";

const FormulaHeader = () => {
  return (
    <div>
      <ul className="nav justify-content-center card-bottom-border">
        <li className="nav-item mr-3">
          <NavLink
            exact
            to="/formula-home"
            className="nav-link  font-weight-bold "
            activeClassName="navlinkcolor-in"
          >
            Home
          </NavLink>
        </li>
        <li className="nav-item mr-3">
          <NavLink
            to="/formula-live"
            className="nav-link font-weight-bold "
            activeClassName="navlinkcolor-in"
          >
            Right Now
          </NavLink>
        </li>
        <li className="nav-item mr-3">
          <NavLink
            to="/formula-all-matches"
            className="nav-link  font-weight-bold "
            activeClassName="navlinkcolor-in"
          >
            All Matches Now
          </NavLink>
        </li>
      </ul>
    </div>
  );
};

export default FormulaHeader;
